import { AttachmentModel } from './../AddRequest/AttachmentModel';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ValidationService from '../../Services/ValidationService';
import WithRender from './ConnectingSenderName.html';
import { Inject } from 'vue-di-container';
import ConnectingSenderNameService from './ConnectingSenderNameService';
import { Toaster } from '../../Services/toast';
import { DropdownModel, ProviderModel } from '../Provider/ProviderModel';
import { SenderType } from '../../shared/Enums/SenderType';
import CITCKeywordsService from '../CITCKeywords/CITCKeywordsService';
import ProviderService from '../Provider/ProviderService';
import UserService from '../../shared/userService/UserService';
import { ConnectingSenderNameModel, SenderViewModel } from './ConnectingSenderNameModel';
import { AddRenewContractRequestModel } from '../RenewContractReques/AddRenewContractRequestModel';
import { AttachmentCategoryType } from '../../shared/Enums/AttachmentCategory';
import RatingService from '@/components/Rating/RatingService';
import { RatingServiceType } from '@/components/Rating/RatingServiceType';
import { ServiceRatingModel } from '@/components/Rating/ServiceRatingModel';
import OperatorService from '@/Services/OperatorService';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ConnectingSenderNameService,
        CITCKeywordsService,
        ProviderService,
        RatingService,
        OperatorService
    ],
})
export default class ConnectingSenderName extends Vue {
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(ConnectingSenderNameService) public connectingSenderNameService!: ConnectingSenderNameService;
    @Inject(CITCKeywordsService) public cITCKeywordsService!: CITCKeywordsService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(UserService) public userService!: UserService;
    @Inject(RatingService) public ratingService!: RatingService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Prop({ type: Number, required: true }) public serviceType!: number;
    @Prop({ type: Boolean, default: false })

    public layoutSup: boolean | any;
    public minDate: Date = new Date();
    public stepNumber: number = 1;
    public senderName: string = '';
    public typeFile: string = '';
    public senderNameLength: number = 11;
    public contractAttachmentName: string = '';
    public senderType: number[] = [];
    public expiryDateFromMenu: boolean = false;
    public sendersList: string[] = [];
    public submitRequestdialog: boolean = false;
    public isCriticalSender: boolean = false;
    public senderNameId: number = 0;
    public showOperators: boolean = false;
    public renewRequestModel: AddRenewContractRequestModel = {
        requestIds: [],
        expiryDate: '',
        contractAttachment: null,
    };
    public showRatingDialog: boolean = false;
    public rating: number = 0;
    public reason: string = '';
    public submitting: boolean = false;
    public headers: any = [
        { text: this.$t('shared.senderName'), value: 'operatorId', align: 'right', sortable: false },
        { text: this.$t('shared.senderType'), value: 'operatorId', align: 'center', sortable: false },
        { text: this.$t('shared.clientName'), value: 'name', align: 'center', sortable: false },
    ];
    public customerTypeList: DropdownModel[] = [
        {
            id: 1,
            name: this.$t('shared.government').toString(),
        },
        {
            id: 2,
            name: this.$t('shared.charity').toString(),
        },
        {
            id: 3,
            name: this.$t('shared.private').toString(),
        },
        {
            id: 4,
            name: this.$t('shared.international').toString(),
        },
    ];

    public senderTypeList: DropdownModel[] = [
        {
            id: SenderType.Advertisement,
            name: this.$t('shared.advertisement').toString(),
        },
        {
            id: SenderType.Service,
            name: this.$t('shared.service').toString(),
        },
        {
            id: SenderType.Awareness,
            name: this.$t('shared.awareness').toString(),
        },
        {
            id: SenderType.Warning,
            name: this.$t('shared.warning').toString(),
        },
    ];
    public operatorList: string[] = [];

    public model: ConnectingSenderNameModel = {
        duration: '1',
        startDate: '',
        clientName: '',
        customerType: 0,
        crNumber: '',
        enterpriseUnifiedNumber: '',
        senderNames: [],
        contractAttachment: null,
        requestType: 7,
        comment: '',
        expiryDate: '',
    };

    senderNames: SenderViewModel[] = [];
    public selected: SenderViewModel[] = [];
    public selectedSendersIds: string[] = [];
    public selectedRequestIds: string[] = [];
    public isRenewBool: boolean = false;
    public isRenew: string | any;

    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        if (this.$route.params.isRenew !== undefined) {
            this.isRenewBool = this.$route.params.isRenew === 'true' ? true : false;
        }
        let user = await this.userService.getUser();
        let providerId = user.details.ProviderId;
        let provider = await this.providerService.GetById(providerId);
        if (!provider.hasInternational) {
            this.customerTypeList.splice(3, 1);
        }
    }

     public async created() {
        const response = await this.operatorService.getAll();

        if (response.isSuccess) {
            this.operatorList = response.result.map((op: any) => op.name);
        }
    }

    public next() {
        if (this.stepNumber === 2 && !this.isRenewBool && !this.isValidComment()) {
            return;
        }
        if (this.stepNumber < 3) {
            this.stepNumber = this.stepNumber + 1;
        }
    }

    private isValidComment(): boolean {
        const comment = this.model.comment ? this.model.comment.trim() : '';
        if (comment.length === 0) {
            return true;
        }
        if (comment.length < 3) {
            Toaster.error(this.$t('shared.commentMinLength').toString());
            return false;
        }
        this.model.comment = comment;
        return true;
    }

    public get isValidApply(): boolean {
        const needsCr = this.model.customerType !== 3;
        const hasCr = this.model.crNumber.trim() !== '';
        const unifiedValid =
            (this.model.customerType === 2 || this.model.customerType === 3)
                ? this.model.enterpriseUnifiedNumber.trim() !== ''
                : true;
        return (
            this.model.customerType !== 0 &&
            (!needsCr || hasCr) &&
            unifiedValid
        );
    }

    public async apply() {
        if (!this.isRenewBool) {
            const response = await this.connectingSenderNameService
                .ConnectingSenderName(this.senderName, this.model.crNumber, this.model.customerType, this.model.enterpriseUnifiedNumber
                );
            if (response.isSuccess) {
                this.senderNames = [];
                this.senderNames = response.result;
                if (this.senderNames.filter(s => s.hasConnectedContract).length != this.senderNames.length && this.headers.length == 3) {
                    const addingType = { text: this.$t('shared.addingType'), value: 'name', align: 'center', sortable: false };
                    const operatorName = { text: this.$t('shared.operatorName'), value: 'name', align: 'center', sortable: false, width: '550px' };
                    this.headers.splice(3, 0, addingType);
                    this.headers.splice(4, 0, operatorName);
                }
                else if (this.headers.length == 5 && this.senderNames.filter(s => s.hasConnectedContract).length == this.senderNames.length) {
                    this.headers.pop();
                    this.headers.pop();
                } this.senderNames.forEach(name => {
                    name.senderTypes = [];
                    this.getSenderType(name.senderType, name);

                });
                this.senderNames.forEach((item) => {
                    this.$set(item, 'isAutoActivation', false);
                });
                this.selected = [];
                this.selectedSendersIds = [];
                this.selectedRequestIds = [];
            } else {
                Toaster.error(response.errorMessage);
            }
        } else {
            const contractResponse = await this.connectingSenderNameService
                .GetForRenewContract(this.senderName, this.model.crNumber, this.model.customerType, this.model.enterpriseUnifiedNumber);
            if (contractResponse.isSuccess) {
                this.senderNames = [];
                this.senderNames = contractResponse.result;
                this.senderNames.forEach(name => {
                    name.senderTypes = [];
                    this.getSenderType(name.senderType, name);
                });
                this.selected = [];
                this.selectedSendersIds = [];
                this.selectedRequestIds = [];
            } else {
                Toaster.error(contractResponse.errorMessage);
            }
        }
    }

    public back() {
        this.stepNumber = this.stepNumber - 1;
    }

    @Watch('model.customerType', { deep: true })
    public onchangeCustomerType() {
        this.model.crNumber = '';
        this.model.senderNames = [];
        this.model.enterpriseUnifiedNumber = '';
        this.senderNames = [];
        switch (this.model.customerType) {
            case 1:
                this.senderTypeList = [
                    {
                        id: SenderType.Advertisement,
                        name: this.$t('shared.advertisement').toString(),
                    },
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                    {
                        id: SenderType.Awareness,
                        name: this.$t('shared.awareness').toString(),
                    },
                    {
                        id: SenderType.Warning,
                        name: this.$t('shared.warning').toString(),
                    },
                ];
                this.senderType = [];
                this.senderName = '';
                this.model.senderNames = [];
                break;
            case 2:
                this.senderTypeList = [
                    {
                        id: SenderType.Advertisement,
                        name: this.$t('shared.advertisement').toString(),
                    },
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                    {
                        id: SenderType.Awareness,
                        name: this.$t('shared.awareness').toString(),
                    },
                ];
                this.senderType = [];
                this.senderName = '';
                this.model.senderNames = [];
                break;
            case 3:
                this.senderTypeList = [
                    {
                        id: SenderType.Advertisement,
                        name: this.$t('shared.advertisement').toString(),
                    },
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                    {
                        id: SenderType.Awareness,
                        name: this.$t('shared.awareness').toString(),
                    },
                ];
                this.senderType = [];
                this.senderName = '';
                this.model.senderNames = [];
                break;
            case 4:
                this.senderTypeList = [
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                ];
                this.senderType = [SenderType.Service];
                this.senderName = '';
                this.model.senderNames = [];
                break;
        }
    }


    public showsubmitRequestDialog(id: string) {
        this.submitRequestdialog = true;
    }

    public hidesubmitRequestDialog() {
        this.submitRequestdialog = false;
    }

    public async submitRequest() {
        if (!this.isRenewBool && !this.isValidComment()) {
            return;
        }
        this.model.senderNames = this.selected;
        if (!this.isRenewBool) {
            this.model.clientName = this.selected[0].clientName;
            const response = await this.connectingSenderNameService.post(this.model);
            const canRate = await this.ratingService.canRate(RatingServiceType.ContractRequest);
            if (response.isSuccess) {
                this.connectingSenderNameService.addContractRequestEmail(response.result);
                this.stepNumber = 4;
                if (canRate) {
                    this.showRatingDialog = true;
                }
            } else {
                Toaster.error(response.errorMessage);
            }
        } else {
            this.renewRequestModel.requestIds = this.selectedRequestIds;
            this.renewRequestModel.contractAttachment = this.model.contractAttachment;
            this.renewRequestModel.expiryDate = this.model.expiryDate;
            const response = await this.connectingSenderNameService.AddRenewContractRequest(this.renewRequestModel);
            if (response.isSuccess) {
                this.connectingSenderNameService.addContractRequestEmail(response.result);
                this.stepNumber = 4;
            } else {
                Toaster.error(response.errorMessage);
            }
        }
        this.hidesubmitRequestDialog();
    }

    public newRequest() {
        this.reset();
        this.stepNumber = 1;
    }

    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedSendersIds = [];
            this.selectedRequestIds = [];

        } else {
            this.selected = this.senderNames.slice();
            this.selectedSendersIds = this.senderNames.map((x) => x.senderId);
            this.selectedRequestIds = this.senderNames.map((x) => x.id);
        }
    }

    public select(event: any, senderId: string) {
        if (!event) {
            const index = this.selectedSendersIds.indexOf(senderId);
            this.selectedSendersIds.splice(index, 1);
            this.selectedRequestIds.splice(index, 1);
        } else {
            this.selectedSendersIds.push(senderId);
            let element = this.senderNames.find(x => x.senderId == senderId);
            if (element !== undefined) {
                this.selectedRequestIds.push(element.id);
            }
        }
    }


    public get isValidSenderName(): boolean {
        return (this.senderName.trim() !== '' && this.senderName.length <= 11 && this.senderType.length !== 0);
    }

    public deleteContract() {
        this.model.contractAttachment = null;
        this.contractAttachmentName = '';
        (this.$refs.contractAttachment as any).value = '';
    }

    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }

    public getSenderType(type: number, sender: SenderViewModel) {
        sender.senderTypes = [];
        const senderBinary = type;
        if ((senderBinary & 1) === 1) {
            sender.senderTypes.push(1);
        }
        if ((senderBinary & 2) === 2) {
            sender.senderTypes.push(2);
        }
        if ((senderBinary & 4) === 4) {
            sender.senderTypes.push(4);
        }
        if ((senderBinary & 8) === 8) {
            sender.senderTypes.push(8);
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }

    public onPickFile(type: string) {
        this.typeFile = type;
        (this.$refs.contractAttachment as any).click();
    }

    public onFilePicked(event: any) {
        const files: any[] = event.target.files;
        const modelArray: AttachmentModel = {} as AttachmentModel;
        Array.prototype.forEach.call(files, (file, index) => {
            modelArray.fileName = file.name;
            if (file.size > 3000000) {
                Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
            }
            else {
                this.contractAttachmentName = file.name;
                const reader = new FileReader();
                reader.onloadend = (fileData: any) => {
                    modelArray.fileContent = fileData.target.result.split(',')[1];
                    modelArray.attachmentType = this.typeFile;
                    this.model.contractAttachment = modelArray;
                };
                reader.readAsDataURL(file);
            }
        });
    }
    public get isValidStep(): boolean {
        if (this.stepNumber === 1) {
            const hasOpIssue = this.selected.some(
                x => x.isAutoActivation === true && (!x.operators || x.operators.length === 0)
            );
            const unifiedValid =
                (this.model.customerType === 2 || this.model.customerType === 3)
                    ? this.model.enterpriseUnifiedNumber.trim() !== ''
                    : true;

            const needsCr = this.model.customerType !== 3;
            const hasCr = this.model.crNumber.trim() !== '';

            return (
                this.model.customerType !== 0 &&
                (!needsCr || hasCr) &&
                unifiedValid &&
                this.selectedSendersIds.length !== 0 &&
                !hasOpIssue
            );
        } else {
            return (
                this.model.expiryDate !== '' &&
                new Date(this.model.expiryDate) > this.minDate &&
                this.model.contractAttachment != null &&
                this.model.contractAttachment.attachmentType === AttachmentCategoryType.DelegationLetter
            );
        }
    }

    public reset() {
        this.model = {
            duration: '1',
            startDate: '',
            clientName: '',
            crNumber: '',
            enterpriseUnifiedNumber: '',
            customerType: 0,
            senderNames: [],
            contractAttachment: null,
            requestType: 7,
            comment: '',
            expiryDate: '',
        };
        this.contractAttachmentName = '';
        this.senderType = [];
    }

    get reasonRequired(): boolean {
        return this.rating > 0 && this.rating <= 2;
    }

    get canSubmit(): boolean {
        return this.rating > 0 && (!this.reasonRequired || this.reason.trim().length > 0);
    }

    public async submitRating() {
        if (!this.canSubmit) return;
        this.submitting = true;
        const model: ServiceRatingModel = {
            rating: this.rating,
            reason: this.reason,
            serviceType: RatingServiceType.ContractRequest,
        };
        const response = await this.ratingService.addRating(model);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.ratingSuccess').toString());
            this.resetForm();
            this.showRatingDialog = false;
        } else {
            Toaster.error(response.errorMessage);
        }
        this.submitting = false;
    }

    public resetForm() {
        this.rating = 0;
        this.reason = '';
    }
}